<script setup lang="ts">
import { useSlots } from 'vue';

interface Props {
    size: number;
    color?: string;
}

defineProps<Props>();

const slots = useSlots();

</script>

<template>
  <div class="loader"
       :style="{ width: size + 'px', height: size + 'px' }">
    <div class="loader-spinner display-flex align-items-center justify-center"
         v-bind="$attrs"
    ></div>
    <div v-if="slots.default"
         class="loader-content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loader {
  position: relative;
  width: 50px;
  height: 50px;

  &-spinner {
    position: relative;
    width: 100%;
    height: 100%;
    animation: l24 1s infinite linear;
    border: 8px solid #0000;
    border-radius: 50%;
    border-right-color: var(--bg-brand-aviation-primary);
    aspect-ratio: 1;

    &::before,
    &::after {
      content: "";
      position: absolute;
      animation: inherit;
      animation-duration: 2s;
      border: inherit;
      border-radius: 50%;
      inset: -8px;
    }

    &::after {
      animation-duration: 4s;
    }

    @keyframes l24 {
      100% {transform: rotate(1turn)}
    }
  }

  &-content {
    position: absolute;
    z-index: 10;
    top: 53%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
